import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsyncValidatorFn, AbstractControl } from '@angular/forms';
import { timer, Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { Events } from 'src/app/shared/models/event.model';
import { CRUDModel, PaginationArgs } from 'src/app/shared/models/pagination.args.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  paginationArgs: PaginationArgs = { pageNumber: 1, pageSize: 10 };
  public apiUrl = environment.apis.baseUrl;

  constructor(private http: HttpClient) { }
  
  eventsFilter(paginationArgs = this.paginationArgs, filterObject = {}, sort = { order_by: 'startingDate', order_by_sorting: 'ASC' }) {
    let params = new HttpParams();
    params = params.set('per_page', `${paginationArgs.pageSize}`);
    params = params.set('page', `${paginationArgs.pageNumber}`);
    params = params.set('order_by', `${sort.order_by}`);
    params = params.set('order_by_sorting', `${sort.order_by_sorting}`);
    return this.http.post<CRUDModel<Events>>(this.apiUrl + '/event/filter', filterObject, { params })
  }

  getEventByID(id) {
    return this.http.get<CRUDModel<Events>>(this.apiUrl + '/event/' + id)
  }

  getDescription(id) {
    return this.http.get<any>(this.apiUrl + '/event/description/' + id)
  }

  getSlideHome(){
    return this.http.get<any>(this.apiUrl + '/slider')
  }
}
